import PageArticleDetail from '~/themes/base/components/content/PageArticleDetail'

export default {
  extends: PageArticleDetail,
  async mounted() {
    await this.$nextTick()
    // Opens all article links in new tab/window
    const anchors = document.querySelectorAll('.ContentBuilder__text a')
    anchors.forEach(a => {
      a.setAttribute('target', '_blank')
    })

    // Legacy code for images transferred from old domain
    const images = document.querySelectorAll('.ContentBuilder__text img')
    images.forEach(image => {
      let src = image.getAttribute('src')
      src = src.replace(
        'http://www.ventilator-shop.com/storage/filemanager/source/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace(
        'http://www.ventilator-profis.de/storage/filemanager/source/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/de/',
      )
      src = src.replace(
        'http://www.ventilatory-shop.cz/storage/filemanager/source/articles/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace(
        'https://www.ventilatory-shop.cz/storage/filemanager/source/articles/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace('https://cdn.ventilatory-shop.cz/image/', 'https://cdn.store.cvb-new.prod.inspishop.cz/image/')
      src = src.replace('https://cdn.ventilator-profis.de/image/', 'https://cdn.store.cvb-new.prod.inspishop.cz/image/')
      src = src.replace('../image', 'https://cdn.store.cvb-new.prod.inspishop.cz/image')
      image.setAttribute('src', src)
    })
  },
}
